module.exports = __webpack_public_path__ + "img/tixing.7b1394ef.png";